import { platformIconMap } from 'root/src/shared/constants/dropKeys';
import * as RewardCard from 'root/src/client/web/giveaway/components/RewardCard';
import { useGiveawayRewards } from 'root/src/client/web/giveaway/features/GiveawayRewards/hooks/useGiveawayRewards';
import classnames from 'classnames';
import * as Carousel from 'root/src/client/v2/common/components/Carousel/Carousel';
import Autoplay from 'embla-carousel-autoplay';
import { memo } from 'react';
export const GiveawayRewards = memo(() => {
    const { rewards } = useGiveawayRewards();
    // means user has no rewards available
    if (!(rewards === null || rewards === void 0 ? void 0 : rewards.length))
        return null;
    return (<div className="flex flex-col gap-5">
			<span className="uppercase text-xs text-light-4 mx-4">Reward giveaway options</span>
			<div className="flex justify-center items-center w-full">
				<Carousel.Root loop dragFree plugins={[Autoplay({
                delay: 5000,
                stopOnInteraction: false,
            })]}>
					<Carousel.Container className="-ml-4 flex flex-initial">
						{rewards.map(reward => (<div className="flex-[0_0_40%] md:flex-[0_0_20%] pl-4 flex justify-center items-center">
								<div className="h-96 w-full break-all flex flex-initial items-center justify-center select-none">
									<Reward key={reward.id} reward={reward}/>
								</div>
							</div>))}
					</Carousel.Container>
				</Carousel.Root>
			</div>
		</div>);
});
export const Reward = memo(({ reward }) => {
    const region = 'region' in reward ? `(${reward.region})` : '';
    return (<RewardCard.Root className={classnames('h-full border-2', reward.isClaimed ? 'border-gray-1' : 'border-teal')} key={reward.id}>
			{(reward.isClaimed) && (<RewardCard.ClaimedLabel />)}
			<RewardCard.ImageContainer className={classnames(reward.isClaimed ? 'border-gray-1' : '')}>
				<RewardCard.GameImage src={reward.image} alt={reward.name}/>
			</RewardCard.ImageContainer>
			<RewardCard.GameTitle className="mt-2" title={reward.name}/>
			<RewardCard.Details>
				<RewardCard.RewardTitle className={classnames(reward.isClaimed ? 'text-gray-1' : '')}>
					{reward.name} code <span className="capitalize text-inherit">{region}</span>
				</RewardCard.RewardTitle>
				{typeof reward.platform === 'string' && <RewardCard.PlatformIcon icon={platformIconMap[reward.platform]}/>}
				{reward.restrictions && (<RewardCard.RewardRestrictions>
						{reward.restrictions}
					</RewardCard.RewardRestrictions>)}
			</RewardCard.Details>
		</RewardCard.Root>);
});
